export const ATTACHMENT_TYPES = {
  BLOCKED: 'BLOCKED',
  EMPTY: 'EMPTY',
  IMAGE: 'IMAGE',
  GIF: 'GIF',
  LINK_PREVIEW: 'LINK_PREVIEW',
  VIDEO: 'VIDEO',
  POLLS: 'POLLS',
};

export const COMMBOX_ACTOR_TYPES = {
  PAGE: 'PAGE',
  USER: 'USER',
};
